import { OptimizedSearchResponse } from '@rover/rsdk/src/apiClient/latest';
import { SearchMapData } from '@rover/types';

const getSearchMapData = ({ viewport, derivedData }: OptimizedSearchResponse): SearchMapData => {
  return {
    // @ts-expect-error OptimizedSearchResult and SearchResult are the same data struct but typescript doesn't recognize it
    viewport,
    ...derivedData,
  };
};

export default getSearchMapData;
